import _ from 'lodash';
import React from 'react';

import {SelectField, TextField} from 'components/Fields';

import './styles.css';

const GENDER_OPTIONS = {
  MALE: {
    value: 'Male',
    label: 'Male'
  },
  Female: {
    value: 'Female',
    label: 'Female'
  },
  PREFER_NOT_TO_SAY: {
    value: 'Prefer not to say',
    label: 'Prefer not to say'
  },
  OTHER: {
    value: 'Other',
    label: 'Other'
  }
};

export const getGenderFieldValue = fieldValue =>
  _.get(fieldValue, 'value') || fieldValue;

class GenderField extends React.Component<any> {
  state = {
    isOther: false
  };

  onFieldChange = option => {
    this.props.input.onChange(option);

    this.setState({
      isOther: _.get(option, 'value') === GENDER_OPTIONS.OTHER.value
    });
  };

  getOptions = () => Object.values(GENDER_OPTIONS);

  constructValue = () => {
    // If there is a value from select field, return it
    if (_.isPlainObject(this.props.input.value)) {
      return this.props.input.value;
    }

    // If there is an inital value that is plain object, return it
    if (_.isPlainObject(this.props.meta.initial)) {
      return this.props.meta.initial;
    }

    // If there is a value from text field, return it or get the initial value
    const genderValue = this.props.input.value || this.props.meta.initial;

    // If there is no initial value, return '' in order placeholder to be displayed
    if (_.isNil(genderValue)) {
      return '';
    }

    return {label: genderValue, value: genderValue};
  };

  render() {
    const {input, meta, disabled} = this.props;
    const {isOther} = this.state;

    const options = this.getOptions();

    const selectValue =
      !disabled && isOther ? GENDER_OPTIONS.OTHER : this.constructValue();

    const textValue = getGenderFieldValue(input.value);

    return (
      <div className="GenderField">
        <SelectField
          input={{...input, value: selectValue, onChange: this.onFieldChange}}
          options={options}
          meta={meta}
          disabled={disabled}
          placeholder={'Select gender...'}
        />
        {isOther &&
          !disabled && (
            <TextField input={{...input, value: textValue}} meta={meta} />
          )}
      </div>
    );
  }
}

export default GenderField;
